var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpPage",
    {
      attrs: {
        size: _vm.size,
        header: _vm.documentTitle,
        loaded: _vm.loaded,
        noShow: !_vm.loaded,
        modal: _vm.modal,
        "itp-cname": "CompleteInvoicesAlt",
        modalBindings: _vm.b_7315092382398562_modalBindings
      },
      on: {
        close: function($event) {
          return _vm.evh_7315092382398562_close($event, {})
        }
      }
    },
    [
      _vm.loaded
        ? _c("UcHeader", {
            attrs: {
              slot: "header",
              card: !_vm.modal,
              modal: _vm.modal,
              title: _vm.documentTitle
            },
            on: {
              close: function($event) {
                return _vm.evh_2248226175642056_close($event, {})
              }
            },
            slot: "header"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcBody",
            { attrs: { card: !_vm.modal, modal: _vm.modal } },
            [
              _c("ItpAlert", { attrs: { variant: "info", show: "" } }, [
                _c(
                  "p",
                  { staticClass: "mb-0" },
                  [
                    _c("ItpIcon", { attrs: { fa: "info-circle" } }),
                    _vm._v(" "),
                    _c("ItpText", { attrs: { wrap: "" } }, [
                      _vm._v(
                        "\n          Kiállítás után a számla már nem módosítható.\n        "
                      )
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "ItpForm",
                {
                  ref: "mainForm",
                  attrs: { id: _vm.formId, name: "confirmSyncInvoice" },
                  on: {
                    submit: function($event) {
                      return _vm.evh_4186377094414664_submit($event, {})
                    }
                  }
                },
                [
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "create_register_entry",
                        label: _vm._f("pgettext")("Filing", "InvoiceSync"),
                        helpTooltip: _vm._f("pgettext")(
                          "Create a register entry after issuing the invoice.",
                          "InvoiceSync"
                        ),
                        labelAlign: _vm.labelAlign,
                        labelColsMd: "3",
                        contentColsMd: "9"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "print", required: "" },
                              model: {
                                value: _vm.payload.create_register_entry,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.payload,
                                    "create_register_entry",
                                    $$v
                                  )
                                },
                                expression: "payload.create_register_entry"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "register_entry_subject",
                        label: _vm._f("pgettext")(
                          "Filing subject",
                          "InvoiceSync"
                        ),
                        helpTooltip: _vm._f("pgettext")(
                          "Use the given subject for the register entries.",
                          "InvoiceSync"
                        ),
                        labelColsMd: "3",
                        contentColsMd: "9",
                        labelAlign: _vm.labelAlign,
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-text" },
                          [
                            _c("ItpFormCheckbox", {
                              attrs: { name: "register_entry_subject_enabled" },
                              model: {
                                value: _vm.register_entry_subject_enabled,
                                callback: function($$v) {
                                  _vm.register_entry_subject_enabled = $$v
                                },
                                expression: "register_entry_subject_enabled"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("ItpFormInput", {
                        staticClass: "w-auto",
                        attrs: {
                          name: "register_entry_subject",
                          disabled: !_vm.register_entry_subject_enabled
                        },
                        model: {
                          value: _vm.payload.register_entry_subject,
                          callback: function($$v) {
                            _vm.$set(_vm.payload, "register_entry_subject", $$v)
                          },
                          expression: "payload.register_entry_subject"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "copies",
                        label: _vm._f("pgettext")("Print", "InvoiceSync"),
                        labelAlign: _vm.labelAlign,
                        labelColsMd: "3",
                        contentColsMd: "9",
                        contentClass: "input-group"
                      }
                    },
                    [
                      _c("ItpFormCheckbox", {
                        attrs: { name: "print", required: "" },
                        model: {
                          value: _vm.payload.print,
                          callback: function($$v) {
                            _vm.$set(_vm.payload, "print", $$v)
                          },
                          expression: "payload.print"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "copies",
                        label: _vm._f("pgettext")("Copies", "InvoiceSync"),
                        labelAlign: _vm.labelAlign,
                        labelColsMd: "3",
                        contentColsMd: "2"
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "input-group" },
                        [
                          _c("ItpFormInput", {
                            attrs: {
                              type: "number",
                              name: "print_copies",
                              required: "",
                              disabled: !_vm.payload.print
                            },
                            model: {
                              value: _vm.payload.print_copies,
                              callback: function($$v) {
                                _vm.$set(_vm.payload, "print_copies", $$v)
                              },
                              expression: "payload.print_copies"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "ItpFormGroup",
                    {
                      attrs: {
                        name: "copies",
                        label: _vm._f("pgettext")("Printer", "InvoiceSync"),
                        labelAlign: _vm.labelAlign,
                        labelColsMd: "3",
                        contentColsMd: "9"
                      }
                    },
                    [
                      _c("UcPrinterSelector", {
                        attrs: {
                          item: _vm.payload,
                          path: "printer",
                          clearable: "",
                          disabled: !_vm.payload.print
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded
        ? _c(
            "UcFooter",
            {
              attrs: { slot: "footer", card: !_vm.modal, modal: _vm.modal },
              slot: "footer"
            },
            [
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("pgettext")(
                    "Complete invoices",
                    "CompleteInvoices|Submit"
                  ),
                  disabled:
                    !_vm.forms.confirmSyncInvoice ||
                    !_vm.forms.confirmSyncInvoice.submittable,
                  type: "submit",
                  form: _vm.formId,
                  variant: "primary",
                  icon: "fa-save",
                  spinning: _vm.actions.submit.isRunning
                }
              }),
              _vm._v(" "),
              _c("ItpButton", {
                attrs: {
                  text: _vm._f("gettext")("Cancel"),
                  variant: "default",
                  disabled: _vm.actions.submit.isRunning
                },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.evh_1419464017721962_clickPreventStop($event, {})
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loaded ? _c("template", { slot: "footer" }) : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }